<template>
    <main>
        <div class="unlock-scheme-container">
            <p class="muted" style="margin: 0 0 12px">{{ $t('unlock.description') }}</p>

            <div class="unlock-scheme-block">
                <ton-logo class="unlock-scheme-block__ton-logo" />
                <div class="unlock-scheme-block__info">
                    <div>
                        <div class="muted">{{ $t('unlock.unlocked') }}</div>
                        <div>TON</div>
                    </div>
                    <div style="text-align: right;">
                        <div>
                            <span v-if="isLoaded">{{ $ton(availableToWithdraw, 9, true) }} TON</span>
                            <span v-else class="skeleton">Theres some TON</span>
                        </div>
                        <div>
                            <ui-fiat v-if="isLoaded" v-bind:ton-value="availableToWithdraw" class="muted"/>
                            <span v-else style="color: transparent">skeleton</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="unlock-scheme-block__arrow-down">
                <icon-arrow />
            </div>

            <div class="unlock-scheme-block">
                <ton-logo class="unlock-scheme-block__ton-logo" />
                <div class="unlock-scheme-block__info">
                    <div>
                        <div class="muted">{{ $t('unlock.stake_balance') }}</div>
                        <div>TON</div>
                    </div>
                    <div style="text-align: right;">
                        <div>
                            <span v-if="isLoaded">{{ $ton(stakingBalance, 9, true) }} TON</span>
                            <span v-else class="skeleton">Theres some TON</span>
                        </div>
                        <div class="muted">
                            <ui-fiat v-if="isLoaded" v-bind:ton-value="stakingBalance"/>
                            <span v-else style="color: transparent">skeleton</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="unstake-stats">
                <div class="unstake-stats__row">
                    <div class="muted">{{ $t('unlock.stake_balance_after') }}</div>
                    <div>
                        <span v-if="isLoaded">{{ $ton(newStakeBalance, 9, true) }} TON</span>
                        <span v-else class="skeleton">balance TON</span>
                    </div>
                </div>
                <div class="unstake-stats__row">
                    <div class="muted">{{ $t('unlock.yearly_reward') }}</div>
                    <div>
                        <span v-if="isLoaded">{{ $ton(annualReward, 9, true) }} TON</span>
                        <span v-else class="skeleton">balance TON</span>
                    </div>
                </div>
            </div>

            <button
                class="bright-blue-button"
                style="padding: 12px 0"
                v-on:click="startTxChain"
                v-bind:disabled="!availableToWithdraw || availableToWithdraw === '0'"
                v-bind:style="!availableToWithdraw || availableToWithdraw === '0' ? 'opacity: .7' : ''"
            >
                {{ $t('unlock.btn_stake_unlocked') }}
            </button>
        </div>

        <div class="unlock-rows">
            <div class="jetton-stats-row">
                <div class="jetton-stats-row__name">{{ $t('unlock.stats.available') }}</div>
                <div class="jetton-stats-row__value" v-if="isLoaded">{{ $ton(availableToWithdraw, 9, true) }} TON</div>
                <div class="jetton-stats-row__value" v-else>
                    <span class="skeleton">123,456.7888 TON</span>
                </div>
            </div>

            <div class="jetton-stats-row">
                <div class="jetton-stats-row__name">{{ $t('unlock.stats.still_locked') }}</div>
                <div class="jetton-stats-row__value" v-if="stillLocked !== null">{{ $ton(stillLocked, 9, true) }} TON</div>
                <div class="jetton-stats-row__value" v-else>
                    <span class="skeleton">123,456.7888 TON</span>
                </div>
            </div>

            <div class="jetton-stats-row">
                <div class="jetton-stats-row__name">{{ $t('unlock.stats.deposit') }}</div>
                <div class="jetton-stats-row__value" v-if="totalUserDeposit !== null">{{ $ton(totalUserDeposit, 9, true) }} TON</div>
                <div class="jetton-stats-row__value" v-else>
                    <span class="skeleton">123,456.7888 TON</span>
                </div>
            </div>

            <div class="jetton-stats-row">
                <div class="jetton-stats-row__name">{{ $t('unlock.stats.deposit_reward') }}</div>
                <div class="jetton-stats-row__value" v-if="totalUserDepositAndReward !== null">{{ $ton(totalUserDepositAndReward, 9, true) }} TON</div>
                <div class="jetton-stats-row__value" v-else>
                    <span class="skeleton">123,456.7888 TON</span>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import tonLogo from '@img/icons/tonscan/ton-bg-24.svg?inline';
import iconArrow from '@img/icons/tonscan/arrow-small-right.svg?inline';
import { getUserLockerData } from '~/api/unlock';

export default {
    data() {
        return {
            isLoaded: false,
            stakingBalance: 0,
            availableToWithdraw: 0,
            stillLocked: null,
            totalUserDeposit: null,
            totalUserDepositAndReward: null,
            stakedAPY: 0,
            newStakeBalance: 0,
            annualReward: 0,
        };
    },

    mounted() {
        this.loadLockerData();
    },

    methods: {
        startTxChain() {
            this.$emit('startTxSteps', this.availableToWithdraw);
        },

        async loadLockerData() {
            if (!this.$tonConnect.connected) return;

            const userAddress = this.$tonConnect.wallet.account.address;

            if (!userAddress) return;

            const lockerUserData = await getUserLockerData(userAddress);

            this.availableToWithdraw = lockerUserData.availableToWithdraw;
            this.stillLocked = lockerUserData.stillLocked;
            this.totalUserDeposit = lockerUserData.totalUserDeposit;
            this.totalUserDepositAndReward = lockerUserData.totalUserDepositAndReward;
            this.stakingBalance = lockerUserData.stakingBalance;
            this.stakedAPY = lockerUserData.apy;
            this.newStakeBalance = lockerUserData.newStakeBalance;
            this.annualReward = lockerUserData.annualReward;

            this.isLoaded = true;
        },
    },

    components: {
        tonLogo,
        iconArrow,
    },
};
</script>

<style scoped lang="scss">
.unlock-scheme-container {
    padding: 12px 16px;
    background-color: var(--card-background);
}

.unlock-scheme-block {
    background-color: var(--body-light-muted-color);
    border-radius: 12px;
    padding: 10px 12px;
    //border: 1px solid var(--stroke-separator);
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    gap: 12px;

    &__info {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }

    &__ton-logo {
        width: 34px;
        height: 34px;
    }

    &__arrow-down {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 200;
        background-color: var(--card-background);
        border: 1px solid var(--card-border-color);
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin: -20px 0 -8px 32px;

        svg {
            width: 14px;
            height: 14px;
            color: var(--body-muted-text-color);
            transform: translateY(1px) rotateZ(90deg);
        }
    }
}

.unlock-rows {
    padding: 0 16px;
}

.unstake-stats {
    margin: 16px 0;

    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }
}
</style>
